import axiosSecurity from '@/services/axios/axiosSecurity'

export default class EmpresaService {
  static async getEmpresaById(empresaId) {
    return axiosSecurity.get(`empresas/${empresaId}`).then(res => res.data.data)
  }

  static async criar(body) {
    return axiosSecurity.post('empresas', body)
  }
}
